import { AuthError } from '@cascade/core/auth';
import type { TAuthErrorReason } from '@cascade/core/auth';
import type { TSignInTitleKey } from './SignIn.types.ts';

export const hasAuthReason = (
  error: unknown,
  reason: TAuthErrorReason,
): boolean => error instanceof AuthError && error.reason === reason;

export const getTitleKey = (
  isTermsDeclined: boolean,
  isEmailCheck: boolean,
): TSignInTitleKey => {
  if (isTermsDeclined) {
    return 'signIn.termsDeclined.title';
  }

  if (isEmailCheck) {
    return 'signIn.emailCheck.title';
  }

  return 'signIn.title';
};
